import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BulkUploadFormComponent } from './bulk-upload-form/bulk-upload-form.component';
import { BulkUploadRoutingModule } from './bulk-upload.routing.module';
import { UploadDocumentsComponent } from './upload-documents/upload-documents.component';
import { ContractImportDocumentsComponent } from './contract-import-documents/contract-import-documents.component';
import { ExcelTableEditorModule } from '../cat-edit/excel-table-editor/excel-table-editor.module';




@NgModule({
  declarations: [
    BulkUploadFormComponent,
    UploadDocumentsComponent,
    ContractImportDocumentsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BulkUploadRoutingModule,
    SharedComponentsModule,
    ExcelTableEditorModule
  ]
})
export class BulkUploadModule { }
